import React, { useCallback } from 'react';
import TextEditor from 'ui/TextEditor';

function ParagraphElement({ onChange, disabled, isDragging, content }) {
  const { body } = content;

  const textEditorOnChange = useCallback(
    text => {
      if (onChange) {
        onChange({ body: text });
      }
    },
    [onChange],
  );

  return (
    <TextEditor
      onChange={textEditorOnChange}
      disabled={disabled}
      isDragging={isDragging}
      className="EditorElement-content"
      defaultValue={body}
    />
  );
}

export default ParagraphElement;
